import React, { useEffect, useState, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ProductCustomizeToppingComp, {
  getRenderQuantityModifier,
  getRenderCheckBox,
} from 'organisms/ProductListingCustomizationComponent/Presentation/ProductCustomizeToppingComponent';
import {
  preventFeature,
  setGroupList,
  toggleAccordion,
} from 'organisms/ProductListingModalOptions/AU/CustomizationAccordion/Container/CustomizationAccordionComp';
import PRODUCT_CUSTOM_CONSTANTS from '../Constants/CustomizationConstants';
import {
  getSubHeaderData,
  getModifierByPath,
  checkExcludedModGItem,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { checkAllTrue, getValueOrDefaultObject } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const isUpdatedCheck = (getModGroupObjextPath, pdpPayload) => {
  let updatedFlag = false;
  const modifiersData = getModifierByPath(pdpPayload, getModGroupObjextPath) ?? {};
  const { modifiers } = modifiersData;
  if (modifiers) {
    Object.entries(modifiers).forEach(([key, val]) => {
      let flag = val?.newSelectedFlag !== null ? val?.newSelectedFlag : val?.isSelected;
      let quantityFlag = val?.newQuantity !== null ? val?.newQuantity : val?.quantity;
      let isDefault = val?.isInitialDefault ? val?.isInitialDefault : val?.isDefault;
      if (isDefault !== flag || (isDefault === true && val?.defaultQuantity !== quantityFlag)) {
        updatedFlag = true;
      }
    });
  }
  return updatedFlag;
};

const toShowMaxTag = (showMaxBadge, localized, additionalProperties) => {
  let renderQtyModifier = getRenderQuantityModifier(additionalProperties);
  return checkAllTrue([showMaxBadge, localized, renderQtyModifier]);
};
const toShowRecipeSuffix = (modifiers, localized, modGMax, additionalProperties) => {
  return localized && getRenderCheckBox(modifiers, additionalProperties, modGMax);
};
/**
 *  ProductCustomizeToppingAccordion Component
 * @param {*} props - Object
 */

const ProductCustomizeToppingAccordion = props => {
  const { grouplist = [], tenantData, isModal, isStoreClosed, localized = true, catalog } = props;
  const { HASH_SYMBOL } = MENU_PDP_PAGE_CONSTANTS;
  const { componentOptions = { web: { pdp: {} } }, currencyConversionFactor } = tenantData;
  const {
    web: {
      pdp: { productCustomizationAccordionDefaultOpen, showMaxBadge },
    },
  } = componentOptions;
  const [groupListItems, setGroupListItems] = useState(JSON.parse(JSON.stringify(grouplist)));
  const cartReducer = useSelector(data => data.cartReducer);
  const { MAX_TAG } = PRODUCT_CUSTOM_CONSTANTS;
  const { CUSTOM } = TRANSLATE_MAPPING_KEY;
  const modgroupPayloadData = useRef([]);
  const { userOrderState } = useContext(UserOrderContext);
  const { pdpPayloadData, sopacPDPCustomization } = userOrderState;
  const { isItemAdded = false } = getValueOrDefaultObject(cartReducer);
  useEffect(() => {
    setGroupList(grouplist, setGroupListItems, productCustomizationAccordionDefaultOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(grouplist)]);

  useEffect(() => {
    !isModal && setGroupList(grouplist, setGroupListItems, productCustomizationAccordionDefaultOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isItemAdded, catalog]);

  const getModGroupObjPath = (isModalInfo, modgrpId) => {
    const { showCustomizationModId = '', showCustomizationModGrpId = '' } = sopacPDPCustomization;
    if (isModalInfo) {
      return `${showCustomizationModGrpId}${HASH_SYMBOL}${showCustomizationModId}${HASH_SYMBOL}${modgrpId}`;
    } else {
      return `${modgrpId}`;
    }
  };

  const getQtyPriceNameData = (id, toShowRecipeSuffixtext, max) => {
    let ObjPath = getModGroupObjPath(isModal, id);
    let renderSuffix = toShowRecipeSuffixtext && max > 1;
    return getSubHeaderData(pdpPayloadData, ObjPath, currencyConversionFactor, renderSuffix);
  };
  return groupListItems.map(({ id, name, modifiers, expanded, min, max, additionalProperties }, ind) => {
    let getModGroupObjextPath = getModGroupObjPath(isModal, id);
    const isUpdated = isUpdatedCheck(getModGroupObjextPath, pdpPayloadData);
    const toShowRecipeSuffixtext = toShowRecipeSuffix(modifiers, localized, max, additionalProperties);
    const toShowMaxBadgeText = !toShowRecipeSuffixtext && toShowMaxTag(showMaxBadge, localized, additionalProperties);
    const isAnyExcluded = checkExcludedModGItem(id, pdpPayloadData);
    return (
      <React.Fragment key={ind}>
        <div
          className={`accordian-container ${!expanded && isAnyExcluded ? 'accordian-container-highlight' : ''}`}
          id={'accordion-' + id}
          data-testid={`product-listing-accordion-${ind}`}
        >
          <div className='accordian-header'>
            <div
              className={`${expanded ? 'accordion active' : 'accordion'}`}
              data-testid={`toggle-accordion-${id}`}
              onClick={event => toggleAccordion(groupListItems, event, id, setGroupListItems, preventFeature)}
            >
              <div className='textbadgecontainer'>
                <span className='accordion-test'>{name}</span>
                <div className='badgeContainer'>
                  {toShowMaxBadgeText && (
                    <span className='ml-2 maxBadge'>{`${translateWithI18Next(MAX_TAG)} ${max}`}</span>
                  )}
                  {isUpdated ? <span className='updatedBadge-sopac'>{translateWithI18Next(CUSTOM)}</span> : null}
                </div>
              </div>
            </div>
            <div className='mod-group-sub-header selected-mod'>
              {getQtyPriceNameData(id, toShowRecipeSuffixtext, max)}
            </div>
          </div>
          <div className={`${expanded ? 'panel panel-active' : 'panel'}`}>
            <ProductCustomizeToppingComp
              tenantData={tenantData}
              modifiers={modifiers}
              modgrpData={{
                modgrpId: id,
                modGrpName: name,
                min,
                max,
                additionalProperties,
                modifierLength: modifiers.length,
              }}
              modgroupPayloadData={modgroupPayloadData}
              isModal={isModal}
              isStoreClosed={isStoreClosed}
              catalog={catalog}
            />
          </div>
        </div>
      </React.Fragment>
    );
  });
};
export default ProductCustomizeToppingAccordion;
